// const KEY_LEFT = 37;
const KEY_UP = 38;
// const KEY_RIGHT = 39;
const KEY_DOWN = 40;

export default function keyboardControl(presentations) {
  const methods = {
    [KEY_UP]: 'prev',
    [KEY_DOWN]: 'next',
  };

  document.addEventListener('keydown', e => {
    const key = e.keyCode;
    if (methods[key]) {
      e.preventDefault();
      presentations.presentation[methods[key]]();
    }
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/control/keyboardControl.js